import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE } from '../config/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isAuthenticated: false,
    user: null,
    token: null,
    classIndex: null,
    menuPermissions: [], // 메뉴 권한 정보
  });

  const [loading, setLoading] = useState(true); // 로딩 상태 추가

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userID = localStorage.getItem('User_ID');
    const classIndex = localStorage.getItem('User_Class_IDX'); // User_Class_IDX 가져오기

    if (token && userID && classIndex) {
      setAuth({
        isAuthenticated: true,
        user: { User_ID: userID },
        token: token,
        classIndex: classIndex,
        menuPermissions: JSON.parse(localStorage.getItem('menuPermissions') || '[]'),
      });
    }
    setLoading(false); // 로딩 상태 종료
  }, []);

  // 저장된 권한은 로그인 시점 값이라, 앱을 열 때마다 서버에서 최신 권한으로 갱신한다.
  // (토큰 수명이 길어 권한 변경이 재로그인 전까지 반영되지 않던 문제)
  const refreshMenuPermissions = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const { data } = await axios.get(`${API_BASE}/api/auth/me/menu-permissions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const menuPermissions = data.menu_permissions || [];
      localStorage.setItem('menuPermissions', JSON.stringify(menuPermissions));
      setAuth((prev) => (prev.isAuthenticated ? { ...prev, menuPermissions } : prev));
    } catch (e) {
      // 토큰 만료/무효면 로그아웃시켜 재로그인 유도. 그 외(네트워크 등)는 저장된 권한 유지.
      if (e.response?.status === 401) logout();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    refreshMenuPermissions();
  }, [refreshMenuPermissions]);

  const login = (userData) => {
    setAuth({
      isAuthenticated: true,
      user: { User_ID: userData.User_ID },
      token: userData.token,
      classIndex: userData.User_Class_IDX,
      menuPermissions: userData.menuPermissions || [],
    });

    localStorage.setItem('token', userData.token);
    localStorage.setItem('User_ID', userData.User_ID);
    localStorage.setItem('User_Class_IDX', userData.User_Class_IDX);
    localStorage.setItem('menuPermissions', JSON.stringify(userData.menuPermissions || []));
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('User_ID');
    localStorage.removeItem('User_Class_IDX');
    localStorage.removeItem('menuPermissions');
    localStorage.removeItem('remember');
    setAuth({
      isAuthenticated: false,
      user: null,
      token: null,
      classIndex: null,
      menuPermissions: [],
    });
  };

  // 로딩 중일 때 로딩 스피너 등을 표시
  if (loading) {
    return <div>불러오는 중...</div>;
  }

  return (
    <AuthContext.Provider value={{ auth, login, logout, refreshMenuPermissions, isLoading: loading }}>
      {children}
    </AuthContext.Provider>
  );
};
